import { CorrectiveActions } from '@EHSNavigator/backend';
import clsx from 'clsx';
import React from 'react';
import { Link } from 'react-router';
import HammerIcon from '../../assets/icons/hammer-active-icon.svg?react';
import ChevronLeftIcon from '../../assets/icons/chevron-down-icon.svg?react';

interface CorrectiveActionBannerProps {
  otherClasses?: string;
  correctiveAction: CorrectiveActions;
  baseUrl: string;
}

const CorrectiveActionBanner: React.FC<CorrectiveActionBannerProps> = ({
  otherClasses,
  correctiveAction,
  baseUrl,
}) => {
  const correctiveActionBannerClasses = clsx(
    otherClasses,
    'bg-card-backgrounds/5 border-neutral-tones-text/10 rounded-10 mt-6 flex w-full items-center gap-2.5 border p-15 lg:mt-9',
  );

  return (
    <div
      className={correctiveActionBannerClasses}
      data-testid="corrective-action-banner"
    >
      <HammerIcon className="[&>path]:fill-brand-papery h-12 w-12 md:h-9 md:w-9 lg:h-12 lg:w-12" />
      <div className="flex flex-1 flex-col gap-1 lg:gap-2.5">
        <span className="font-inter-variable text-brand-papery -tracking-form-input lg:-tracking-button text-base leading-5 font-medium lg:text-xl lg:leading-6 lg:font-bold">
          Linked Corrective Action
        </span>
        <div className="flex items-center gap-15">
          <p className="text-neutral-tones-text -tracking-form-input lg:-tracking-text-area text-base leading-5 font-bold capitalize lg:text-lg lg:leading-5">
            {correctiveAction?.title}
          </p>
          <span className="border-l-neutral-tones-text/10 hidden h-5 border-l md:block"></span>
          <p className="font-inter-variable text-neutral-tones-text/80 -tracking-form-label lg:-tracking-form-input hidden text-sm leading-5 font-normal whitespace-nowrap md:block lg:text-base">
            Reference ID{' '}
            <span className="text-neutral-tones-text/50 uppercase">
              {correctiveAction?.correctActionRefId}
            </span>
          </p>
        </div>
      </div>
      <Link target="_blank" to={`${baseUrl}/${correctiveAction?.id}`}>
        <ChevronLeftIcon className="[&>path]:fill-neutral-tones-text h-6 w-6 -rotate-90 md:h-12 md:w-12" />
      </Link>
    </div>
  );
};

export default CorrectiveActionBanner;
